import type { AppLinkPlatform } from '@pams/shared';

/**
 * [APP-LINK] This page's own words.
 *
 * ⚠️ THE ONE ANSWER TO A REQUEST IS NOT HERE. `APP_LINK_ACCEPTED_MESSAGE` lives in `@pams/shared`
 * beside the API's 202, so the sentence the page shows and the sentence the server sends are one
 * string and cannot drift apart.
 */
export const DOWNLOAD_APP_COPY = {
  /** The officer app's name, as the store and the SMS call it. The dashboard calls itself "PA Admin". */
  wordmark: 'KP Duty Mitra',
  title: 'Download KP Duty Mitra',
  /**
   * ⚠️ AN INSTRUCTION, NEVER A PROMISE. The page cannot know whether a number is an officer's, and must
   * not — so nothing here says a link "will be sent". The conditional sentence after a request is the
   * shared one.
   */
  subtitle: 'Enter the mobile number registered with your unit and choose your phone type.',
  phoneLabel: 'Mobile number',
  phonePlaceholder: '10-digit mobile number',
  platformLabel: 'Phone type',
  submit: 'Send download link',
  again: 'Send to another number',
} as const;

/**
 * The words for each phone type. `satisfies Record<AppLinkPlatform, string>`, so a platform added to
 * the shared tuple is a compile error here until it has words — never an option that renders blank.
 */
export const PLATFORM_LABEL = {
  android: 'Android',
  ios: 'iPhone (iOS)',
} as const satisfies Record<AppLinkPlatform, string>;
